import api from '../../helpers/api';

export const getArtisanProducts = (body) => api.post('artisan-product/search-artisan-products/', {...body})

export const getArtisanProduct = (id) => api.get(`artisan-product/get-single-product/${id}`)

export const createArtisanProduct = (formData) => api.post('artisan-product/' , {...formData})

export const addEditorsReview = (id,formData) => api.post('artisan-product/add-editors-review/' , {id,...formData})

export const updateArtisanProduct = ( id , formData) => api.put(`artisan-product/${id}` , {...formData})


export const getArtisanProductsPictures = () => api.get('artisan-product/get-products-pictures?offset=0&size=10')